const MundTb3 = (props) => (
  <svg
    width={88}
    height={56}
    viewBox="0 0 88 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_0_91)">
      <rect
        x={3.5051}
        y={13.8579}
        width={40}
        height={40}
        rx={10}
        transform="rotate(-15 3.5051 13.8579)"
        fill="url(#paint0_linear_0_91)"
      />
      <g clipPath="url(#clip1_0_91)">
        <path
          d="M26.0784 15.3202L25.2323 16.5812C25.1137 16.7583 24.8857 16.8194 24.6944 16.7253L23.3278 16.0524C23.2184 15.9983 23.0888 15.9926 22.9778 16.039C22.2989 16.321 21.6256 16.6682 20.9645 17.0789C17.4745 19.2485 15.2677 23.0548 15.1144 27.1758C14.8344 34.8437 20.5854 40.395 27.1836 40.8291C28.5431 40.9176 29.9399 40.7912 31.3279 40.4193C32.7159 40.0474 33.9887 39.4584 35.1218 38.702C39.5811 35.7222 41.8728 30.0987 40.4029 24.6132C38.7156 18.3162 32.6425 14.343 26.3742 15.1313C26.2527 15.1472 26.1427 15.2148 26.0734 15.3192L26.0784 15.3202ZM18.1567 31.7824L18.1583 31.7796L21.9768 30.7564C22.1773 30.8671 22.2941 30.9311 22.4924 31.0424C23.3439 33.6622 24.4823 35.8833 25.7498 37.5146C25.9997 37.8361 25.7042 38.2918 25.3115 38.1897C22.1251 37.3395 19.406 35.0105 18.1528 31.7858L18.1567 31.7824ZM30.8032 38.16C30.7772 38.1693 30.7529 38.1759 30.7285 38.1824C30.7042 38.1889 30.6798 38.1954 30.6527 38.2003C29.2128 38.467 26.4752 35.7235 24.7361 30.4817C24.6597 30.2496 24.7942 29.9991 25.0289 29.9362L31.5415 28.1912C31.7761 28.1283 32.0179 28.278 32.0678 28.5172C33.1826 33.9262 32.1813 37.6716 30.8032 38.16ZM35.4213 35.4808C35.135 35.7672 34.6507 35.518 34.7041 35.1153C34.9993 32.9676 34.8455 30.3301 34.1991 27.4838C34.1985 27.4816 34.2007 27.481 34.2007 27.481L33.7103 25.651C33.6496 25.4242 33.4164 25.2889 33.1906 25.3494L18.0248 29.4131C17.7702 29.4813 17.5201 29.3005 17.492 29.0363C17.1488 25.7895 18.3301 22.6274 20.5519 20.4091C20.8404 20.1221 21.3231 20.3741 21.2681 20.7797C21.0629 22.2717 21.0754 24.0009 21.3169 25.8761C21.3492 26.1296 21.603 26.2975 21.8487 26.2317L23.2677 25.8515C23.4713 25.7969 23.6029 25.5972 23.5775 25.3872C23.0536 21.0591 23.9676 18.1569 25.17 17.7299L25.3183 17.6902C26.5731 17.4588 28.818 19.5145 30.5261 23.5253C30.6091 23.7199 30.8207 23.8277 31.0266 23.7725L32.4433 23.3929C32.689 23.327 32.8254 23.0569 32.7261 22.819C32.0026 21.0753 31.1467 19.5721 30.2246 18.3798C29.9747 18.0583 30.2684 17.5959 30.6595 17.7008C33.8381 18.5483 36.5498 20.8674 37.8072 24.0814C37.8119 24.0992 37.8189 24.1164 37.8237 24.1342L38.4106 26.3244C38.4153 26.3422 38.4201 26.36 38.4226 26.3783C38.9407 29.7905 37.7497 33.1553 35.4207 35.4785L35.4213 35.4808Z"
          fill="url(#paint1_linear_0_91)"
        />
      </g>
    </g>
    <path
      d="M42.545 15.869C43.7046 11.5412 44.2844 9.37732 45.5696 7.95002C46.7 6.69452 48.1989 5.82913 49.8514 5.47788C51.7301 5.07856 53.894 5.65837 58.2217 6.81799L72.131 10.545C76.4588 11.7046 78.6227 12.2844 80.05 13.5696C81.3055 14.7 82.1709 16.1989 82.5221 17.8514C82.9214 19.7301 82.3416 21.894 81.182 26.2217L77.455 40.131C76.2954 44.4588 75.7156 46.6227 74.4304 48.05C73.3 49.3055 71.8011 50.1709 70.1486 50.5221C68.2699 50.9214 66.106 50.3416 61.7783 49.182L47.869 45.455C43.5412 44.2954 41.3773 43.7156 39.95 42.4304C38.6945 41.3 37.8291 39.8011 37.4779 38.1486C37.0786 36.2699 37.6584 34.106 38.818 29.7783L42.545 15.869Z"
      fill="url(#paint2_linear_0_91)"
    />
    <path
      d="M63.6297 16.6988C64.2303 17.5502 64.423 18.3445 64.2524 19.3555C64.1814 19.6558 64.1002 19.9511 64.0135 20.2472C63.9863 20.3464 63.9591 20.4455 63.9311 20.5477C63.7586 21.163 63.5483 21.7515 63.3039 22.3421C63.3415 22.2929 63.3791 22.2436 63.4178 22.1928C65.6639 19.2662 65.6639 19.2662 67.4075 19.0363C68.3567 18.9944 69.2631 19.273 69.9881 19.8925C70.6224 20.5671 71.0824 21.3952 71.0944 22.3133C71.0203 23.0695 70.8591 23.7587 70.359 24.3472C70.4341 24.3772 70.5092 24.4072 70.5867 24.4382C71.6447 24.8904 72.2204 25.44 72.702 26.4618C73.0171 27.244 72.9651 27.9794 72.7339 28.7657C72.3037 29.68 71.6535 30.2646 70.7178 30.6848C69.5276 31.0601 68.1483 30.6496 66.9777 30.3251C66.871 30.2959 66.7643 30.2668 66.6543 30.2368C66.3936 30.1656 66.1331 30.094 65.8727 30.0218C65.9969 30.1037 66.1212 30.1856 66.2492 30.27C69.1184 32.1868 69.1184 32.1868 69.5586 33.6692C69.7285 34.5606 69.5674 35.4417 69.1146 36.2253C68.5092 37.0171 67.668 37.5423 66.6581 37.7008C65.8861 37.704 64.9911 37.4805 64.3423 37.0615C64.3042 37.1386 64.2661 37.2157 64.2269 37.2952C63.697 38.3057 63.069 39.0172 61.9371 39.397C60.9533 39.676 60.079 39.4791 59.148 39.066C58.4284 38.6347 57.8936 37.8324 57.6446 37.064C57.4164 35.7144 57.8059 34.2914 58.0816 32.9771C58.012 33.0861 57.9425 33.1951 57.8708 33.3074C56.33 35.6792 54.2853 37.7463 51.4598 38.6526C51.0803 38.5408 50.958 38.4333 50.7469 38.1034C50.6116 37.6668 50.6176 37.4056 50.7254 36.9659C51.0286 36.7633 51.0286 36.7633 51.4183 36.6214C51.5532 36.5694 51.6881 36.5173 51.8271 36.4637C51.9504 36.4195 52.0738 36.3753 52.2008 36.3297C53.0347 36.0169 53.6694 35.5072 54.3482 34.9567C54.4294 34.8914 54.5107 34.8262 54.5944 34.759C55.4044 34.055 56.5638 32.8861 56.8433 31.843C56.7534 31.9423 56.6635 32.0416 56.5709 32.1439C54.1333 34.7915 54.1333 34.7915 52.352 34.8802C51.277 34.6789 50.3237 34.4553 49.6174 33.5745C49.0733 32.7937 48.8407 31.9501 48.952 31.0202C49.1145 30.2817 49.4577 29.7604 49.9601 29.1964C49.8529 29.1582 49.7457 29.12 49.6352 29.0807C48.7937 28.72 48.2241 28.0762 47.8689 27.2607C47.6269 26.3564 47.5894 25.4732 48.0422 24.6357C48.5841 23.795 49.2644 23.325 50.2078 22.9591C51.7832 22.6288 53.6707 23.5586 55.1066 24.1571C55.0138 24.0754 54.921 23.9936 54.8254 23.9094C52.1657 21.5456 52.1657 21.5456 52.0672 20.0046C52.0878 19.0349 52.4125 18.1984 53.131 17.5215C53.9113 16.9074 54.6817 16.6363 55.6981 16.6366C56.5034 16.7503 57.0872 17.0191 57.7152 17.5209C57.7494 17.458 57.7837 17.3951 57.8191 17.3303C58.3471 16.4221 59.0246 15.866 60.0344 15.5063C61.4353 15.2494 62.682 15.6152 63.6297 16.6988ZM57.2652 31.1538C57.29 31.5043 57.29 31.5043 57.29 31.5043L57.2652 31.1538ZM58.4215 32.1513C58.4749 32.3948 58.4749 32.3948 58.4749 32.3948L58.4215 32.1513Z"
      fill="url(#paint3_linear_0_91)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_0_91"
        x1={23.5051}
        y1={13.8579}
        x2={23.5051}
        y2={53.8579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29282C" />
        <stop offset={1} stopColor="#100F11" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_91"
        x1={10.6937}
        y1={13.857}
        x2={35.8059}
        y2={35.4542}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_0_91"
        x1={65.1764}
        y1={8.68148}
        x2={54.8236}
        y2={47.3185}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#119A3E" />
        <stop offset={1} stopColor="#175D2E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_0_91"
        x1={52.3041}
        y1={7.67905}
        x2={62.9491}
        y2={38.0705}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_0_91">
        <rect
          x={3.5051}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.5051 13.8579)"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_0_91">
        <rect
          width={30}
          height={30}
          fill="white"
          transform="translate(9.62913 17.3935) rotate(-15)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default MundTb3;